import React, { useEffect, useState } from 'react';
import { FormatMoneyLocal } from '@elem/ui-common/utils/FormatMoneyLocal';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation } from 'swiper';
import { Swiper as SwiperType } from 'swiper/types';
import { Charging, Style, Screen } from '../icons';
import css from './index.module.scss';
import { useLang } from '@/i18n';
import getLocal from '@/app/utils/i18n';
import gtm from '@/utils/gtm';

const icon = (
    <svg xmlns="http://www.w3.org/2000/svg" width="44" height="45" viewBox="0 0 44 45" fill="none">
        <path
            d="M6.25977 0.719238L0.6875 6.60889V37.4536L6.25977 43.3442H37.0293L43.3125 37.4302V6.63232L37.0293 0.719238H6.25977Z"
            stroke="white"
            strokeWidth="1.375"
        />
        <mask id="path-2-inside-1_3127_21607_G1" fill="white">
            <path d="M17.4167 33.0317L28.4167 22.0317L17.4167 11.0317" />
        </mask>
        <path
            d="M18.389 34.004L17.4167 34.9763L15.4722 33.0317L16.4445 32.0595L18.389 34.004ZM28.4167 22.0317L29.389 21.0595C29.926 21.5964 29.926 22.467 29.389 23.004L28.4167 22.0317ZM16.4445 12.004L15.4722 11.0317L17.4167 9.08719L18.389 10.0595L16.4445 12.004ZM16.4445 32.0595L27.4445 21.0595L29.389 23.004L18.389 34.004L16.4445 32.0595ZM27.4445 23.004L16.4445 12.004L18.389 10.0595L29.389 21.0595L27.4445 23.004Z"
            fill="white"
            mask="url(#path-2-inside-1_3127_21607_G1)"
        />
    </svg>
);

const Index: React.FC = ({}) => {
    const { t } = useLang('rapidpro');
    const { locale = 'us' } = getLocal();

    const [mode, setMode] = useState<'swiper' | 'display'>('display');
    const [activeTab, setActiveTab] = useState(0);
    const [activeSubTab, setActiveSubTab] = useState(-1);

    const IS_JP = locale === 'jp';
    const list = [
        [
            {
                img: 'https://websiteoss.ecoflow.com/upload/image/1747981639598/7_1_1_1.png',
                activeImg: 'https://websiteoss.ecoflow.com/upload/image/1747981639782/7_1_1_2.png',
                text: t('G_item1_text'),
                tab: t('G_item1_tab'),
            },
            {
                img: 'https://websiteoss.ecoflow.com/upload/image/1747981639433/7_1_0.png',
                tab: '',
            },
            {
                img: 'https://websiteoss.ecoflow.com/upload/image/1747981639968/7_1_2_1.png',
                activeImg: 'https://websiteoss.ecoflow.com/upload/image/1747981640749/7_1_2_2.png',
                text: t('G_item2_text'),
                tab: t('G_item2_tab'),
                price: IS_JP ? 8990 : undefined,
            },
        ],
        [
            {
                img: 'https://websiteoss.ecoflow.com/upload/image/1747981641146/7_2_1_1.png',
                activeImg: 'https://websiteoss.ecoflow.com/upload/image/1747981641325/7_2_1_2.png',
                text: t('G_item3_text'),
                tab: t('G_item3_tab'),
                price: IS_JP ? 2990 : undefined,
            },
            {
                img: 'https://websiteoss.ecoflow.com/upload/image/1747981640925/7_2_0.png',
                tab: '',
            },
            {
                img: 'https://websiteoss.ecoflow.com/upload/image/1747981641521/7_2_2_1.png',
                activeImg: 'https://websiteoss.ecoflow.com/upload/image/1747981641725/7_2_2_2.png',
                text: t('G_item4_text'),
                tab: t('G_item4_tab'),
                price: IS_JP ? 2990 : undefined,
            },
        ],
        [
            {
                img: 'https://websiteoss.ecoflow.com/upload/image/1749023987625/7_3_1.png',
                text: t('G_item5_text'),
                tab: t('G_item5_tab'),
            },
            {
                img: 'https://websiteoss.ecoflow.com/upload/image/1749023988234/7_3_2.png',
                text: t('G_item5_text'),
                tab: t('G_item5_tab'),
            },
            {
                img: 'https://websiteoss.ecoflow.com/upload/image/1749023987805/7_3_3.png',
                text: t('G_item5_text'),
                tab: t('G_item5_tab'),
            },
            {
                img: 'https://websiteoss.ecoflow.com/upload/image/1749023988450/7_3_4.png',
                text: t('G_item5_text'),
                tab: t('G_item5_tab'),
            },
            {
                img: 'https://websiteoss.ecoflow.com/upload/image/1749024023980/7_3_5.png',
                text: t('G_item6_text'),
                tab: t('G_item6_tab'),
            },
        ],
    ];
    const tabs = [
        {
            tab: t('G_tab1'),
            icon: Charging,
            subs: [t('G_item1_tab'), '', t('G_item2_tab')],
        },
        {
            tab: t('G_tab2'),
            icon: Style,
            subs: [t('G_item3_tab'), '', t('G_item4_tab')],
        },
        {
            tab: t('G_tab3'),
            icon: Screen,
            subs: [t('G_item5_tab'), '', t('G_item6_tab')],
        },
    ];
    const handleTabClick = (index: number, e: any) => {
        setActiveTab(index);
        setMode(index === 2 ? 'swiper' : 'display');
        handleSubTabClick(index === 2 ? 0 : -1);

        setTimeout(() => {
            const parent = document.querySelector('.box .tabs');
            if (parent) {
                const target = parent.querySelector(`.tab:nth-child(${index + 1})`);
                if (target) {
                    const { width, left } = target.getBoundingClientRect();
                    parent.scrollTo({
                        left: left + width / 2 - parent.clientWidth / 2,
                        behavior: 'smooth',
                    });
                }
            }
        }, 20);
    };
    const handleSubTabClick = (index: number) => {
        setActiveSubTab(index);
    };

    // 当前选择 list
    const curTabList: any[] = list[activeTab];
    const handleLeft = () => {
        if (mode === 'display') {
            handleSubTabClick(0);
        }
        handleGTM(1);
    };
    const handleRight = () => {
        if (mode === 'display') {
            handleSubTabClick(2);
        }
        handleGTM(2);
    };

    const [swiper, setSwiper] = useState<SwiperType>();
    const handleSlideChange = (e) => {
        if (mode === 'swiper') {
            const index = e.activeIndex;
            handleSubTabClick(index);
        }
    };
    const handlerSwiperChange = (index: number) => {
        handleSlideChange(index);
        if (swiper) {
            swiper.slideTo(index);
        }
    };

    const handleGTM = (num: number) => {
        gtm.push({
            event: 'uaEvent',
            event_name: 'product_detail_page',
            list_name: t('G_title'),
            button_name: num === 1 ? 'Left switch' : num === 2 ? 'Right switch' : 'none',
            __btn_id1: `accessories-display .item-${num === 1 ? 'prev' : 'next'}`,
            __btn_id2: num === 2 ? '>' : '<',
            __btn_type: 'text',
        });
    };

    return (
        <div className={`${css.css} box`}>
            {mode === 'display' ? (
                <>
                    <div className={`accessories-display  list-${mode} ${mode === 'display' && activeSubTab !== -1 ? 'hide-center' : ''}`}>
                        {curTabList.map((item, idx) => (
                            <div
                                className={`card ${activeSubTab === idx && mode === 'display' ? 'active' : ''}`}
                                style={{
                                    '--img': `url(${item.img})`,
                                    '--active-img': `url(${item?.activeImg || item.img})`,
                                    '--sub-tab-num': `${activeSubTab}`,
                                }}
                                key={idx}
                            >
                                <div
                                    className="card-img GtmModuleData-btn-text"
                                    onClick={() => {
                                        if (idx === 0) {
                                            handleLeft();
                                        } else if (idx === 2) {
                                            handleRight();
                                        }
                                    }}
                                ></div>
                                <div className="card-info" style={{ opacity: activeSubTab === idx ? 1 : 0 }}>
                                    <p className="card-text">{item.text}</p>
                                    <p className="card-price">{item?.price ? FormatMoneyLocal(item?.price || 0, locale) : ''}</p>
                                </div>
                            </div>
                        ))}
                        <div className="btns">
                            <button className={`btn-left GtmModuleData-btn-text ${activeSubTab === 0 ? 'disabled' : ''}`} onClick={() => handleLeft()}>
                                {icon}
                            </button>
                            <button
                                className={`btn-right GtmModuleData-btn-text ${activeSubTab >= curTabList.length - 1 ? 'disabled' : ''}`}
                                onClick={() => handleRight()}
                            >
                                {icon}
                            </button>
                        </div>
                    </div>
                </>
            ) : (
                <Swiper
                    modules={[Navigation]}
                    className="swiper"
                    spaceBetween={0}
                    slidesPerView={'auto'}
                    initialSlide={0}
                    centeredSlides={true}
                    navigation={{
                        prevEl: `.box .item-prev`,
                        nextEl: `.box .item-next`,
                    }}
                    onSwiper={(swipwerIns: SwiperType) => setSwiper(swipwerIns)}
                    onSlideChange={handleSlideChange}
                >
                    {curTabList?.map((item, k: number) => (
                        <SwiperSlide className={`item`} key={k}>
                            <img src={item.img} loading="lazy" />
                            <div className={`card-info ${k === activeSubTab ? 'active' : ''}`}>
                                <p className="item-text">{item.text}</p>
                                <p className="item-price">{item?.price ? FormatMoneyLocal(item?.price || 0, locale) : ''}</p>
                            </div>
                        </SwiperSlide>
                    ))}
                    <div className="swiper-button">
                        <button
                            className={`item-prev item-btn GtmModuleData-btn-text ${activeSubTab <= 0 ? 'swiper-button-disabled' : ''}`}
                            onClick={() => handleLeft()}
                        >
                            {icon}
                        </button>
                        <button
                            className={`item-next item-btn GtmModuleData-btn-text ${activeSubTab >= curTabList.length - 1 ? 'swiper-button-disabled' : ''}`}
                            onClick={() => handleRight()}
                        >
                            {icon}
                        </button>
                    </div>
                </Swiper>
            )}

            <ul className="tabs">
                {tabs.map((tab, k: number) => {
                    const isActive = k === activeTab;
                    const isActiveSub = activeSubTab !== -1;
                    return (
                        <li
                            className={`tab tab-${k + 1} GtmModuleData-btn-text ${isActiveSub ? 'activeSub' : ''} ${isActive ? 'active' : ''}`}
                            onClick={
                                isActive
                                    ? undefined
                                    : (e) => {
                                          handleTabClick(k, e);
                                          gtm.push({
                                              event: 'uaEvent',
                                              event_name: 'tab_click',
                                              list_name: t('G_title'),
                                              button_name: tab.tab,
                                              __btn_id1: `accessories-display .tab-${k + 1}`,
                                              __btn_id2: tab.tab,
                                              __btn_type: 'text',
                                          });
                                      }
                            }
                            key={k}
                        >
                            <div className="tab-inner">
                                <div className="tab-icon">{tab.icon}</div>
                                {isActive ? (
                                    <ul className="tab-subs">
                                        {tab.subs?.map(
                                            (sub: string, m: number) =>
                                                sub && (
                                                    <li
                                                        className={`sub GtmModuleData-btn-text ${
                                                            mode === 'swiper' && activeSubTab > 3 && m > 1 ? 'active' : ''
                                                        } ${activeSubTab} ${mode === 'swiper' && m <= 1 && activeSubTab <= 3 ? 'active' : ''} ${
                                                            mode === 'display' && activeSubTab === m ? 'active' : ''
                                                        }`}
                                                        onClick={() => {
                                                            if (mode === 'swiper') {
                                                                handlerSwiperChange(m === 0 ? 0 : 4);
                                                            } else {
                                                                handleSubTabClick(m);
                                                            }

                                                            gtm.push({
                                                                event: 'uaEvent',
                                                                event_name: 'tab_click',
                                                                list_name: t('G_title'),
                                                                button_name: sub,
                                                                __btn_id1: `accessories-display .tab-${k + 1} .sub`,
                                                                __btn_id2: sub,
                                                                __btn_type: 'text',
                                                            });
                                                        }}
                                                        key={`${k}_${m}`}
                                                    >
                                                        {sub}
                                                    </li>
                                                ),
                                        )}
                                    </ul>
                                ) : (
                                    <span className="tab-text">{tab.tab}</span>
                                )}
                            </div>
                        </li>
                    );
                })}
            </ul>
        </div>
    );
};
export default Index;
